module.exports = __webpack_public_path__ + "img/taiwan_Railways.960148fc.svg";